import { z } from 'zod'

export const rolesValidation = z.object({
  name: z.string().min(1, { message: 'Role name must not be blank' }).max(30, { message: 'Role name must not be longer than 50 characters' }),
  desp: z.string().max(255, { message: 'Description must not be longer than 255 characters' }).optional(),
  remarks: z.string().max(255, { message: 'Remarks must not be longer than 255 characters' }).optional(),
})

export type RolesValidation = z.infer<typeof rolesValidation>
